import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BarcodeScannerService {
  private buffer = '';
  private barcodeSubject = new Subject<string>();

  /** Raw barcode stream (unprocessed) */
  barcode$ = this.barcodeSubject.asObservable();

  /** Barcode stream with noise removed (extracts content after last #) */
  cleanBarcode$ = this.barcodeSubject.asObservable().pipe(map((code) => this.extractRollNumber(code)));

  constructor() {
    this.listenForScannerInput();
  }

  private listenForScannerInput() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        if (this.buffer.length > 0) {
          this.barcodeSubject.next(this.buffer);
          this.buffer = ''; // Clear buffer
        }
      }
      // Ignore Shift key and non-character keys
      else if (!event.ctrlKey && !event.altKey && !event.metaKey && event.key !== 'Shift') {
        this.buffer += event.key;
      }
    });
  }

  emitBarcode(code: string): void {
    this.barcodeSubject.next(code);
  }

  /**
   * Extracts the roll number from a QR code by removing noise.
   * If the scanned value contains # characters, returns only the substring after the last #.
   * This matches the behavior of the QR scanner component.
   * @param rawCode The raw scanned QR code or barcode
   * @returns The extracted roll number or the original code if no # is found
   */
  extractRollNumber(rawCode: string): string {
    if (!rawCode) return rawCode;

    const lastHashIndex = rawCode.lastIndexOf('#');
    if (lastHashIndex !== -1 && lastHashIndex < rawCode.length - 1) {
      return rawCode.substring(lastHashIndex + 1);
    }

    return rawCode;
  }
}
